//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit"


interface State {
    history: any
}

const initialState: State = {
    history: null
}


const slice = createSlice({
    name: "migration",
    initialState,
    reducers: {
        setHistory: (state, action: PayloadAction<any>) => {
            return { ...state, history:action.payload }
        }
    }
})


export const { setHistory } = slice.actions;
export const selectMigrationHistory = (state: { migration: State }) => state.migration.history;
export default slice.reducer;